import { useEffect } from "react";

/**
 * Keyboard navigation helper for the assessment page.
 * - Enter / ArrowRight → next
 * - ArrowLeft / Backspace → back
 * - 1–4 → select option by index (for card questions)
 */
export function useKeyboardNav({ onNext, onBack, onSelectIndex, enabled = true }) {
  useEffect(() => {
    if (!enabled) return;

    const handler = (e) => {
      // Don't intercept when typing in an input
      if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA") return;

      switch (e.key) {
        case "Enter":
        case "ArrowRight":
          e.preventDefault();
          onNext?.();
          break;
        case "ArrowLeft":
          e.preventDefault();
          onBack?.();
          break;
        case "1":
        case "2":
        case "3":
        case "4":
          e.preventDefault();
          onSelectIndex?.(parseInt(e.key, 10) - 1);
          break;
        default:
          break;
      }
    };

    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onNext, onBack, onSelectIndex, enabled]);
}
